/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Voice_Manager_Unpin_Success_ToastInputs */



/**
* | output |
* | --- |
* | "{name} un-pinned successfully" |
*
* @param {Voice_Manager_Unpin_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_unpin_success_toast = /** @type {((inputs: Voice_Manager_Unpin_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Unpin_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.name} depingle avec succes`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.name} wurde erfolgreich vom Fixierungspunkt getrennt.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.name} sbloccato con successo`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.name} успешно откреплен`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.name} desanclado exitosamente`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.name} 已成功解除固定`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.name} のピン留めが正常に解除されました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.name} सफलतापूर्वक अनपिन हो गया`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`${i?.name} desfixado com sucesso`)
	return /** @type {LocalizedString} */ (`${i?.name} un-pinned successfully`)
});